import CdnBackgroundImage from 'components/CdnBackgroundImage'
import PromotionLink from 'components/PromotionLink'
import React from 'react'
import styled from 'styled-components'
import {
  mediaExtraLargeScreens,
  mediaMaxLBreakpoint,
} from 'uiComponents/constants/customMedia'

const StyledCdnBackgroundImage = styled(CdnBackgroundImage)<{
  imageBackgroundSize: string
}>`
  background-size: ${props => props.imageBackgroundSize};
  .container {
    position: relative;
    height: 100%;
    background-size: cover;
    background-position: 100% 0%;
    background-repeat: no-repeat;

    @media ${mediaExtraLargeScreens} and (max-width: ${mediaMaxLBreakpoint}px) {
      background-size: cover;
    }
  }
`

interface Props {
  image: { hash: string; url?: string }
  imagePosition?: string
  imageBackgroundSize?: string
}

function renderImage(
  image: Props['image'],
  imageBackgroundSize: Props['imageBackgroundSize'] = 'cover',
) {
  return (
    <StyledCdnBackgroundImage
      imageBackgroundSize={imageBackgroundSize}
      imageHash={image.hash}
      width={2000}
      height={1200}
    />
  )
}

const Slide: React.FC<Props> = ({ image, imageBackgroundSize }) => {
  if (image.url) {
    return (
      <PromotionLink to={image.url}>
        {renderImage(image, imageBackgroundSize)}
      </PromotionLink>
    )
  }

  return renderImage(image)
}

export default Slide
